import { useDashboard, useHandleApiCall, useNotification } from '../../hooks';
import { Fragment, useEffect, useState } from 'react';
import { Box } from '@mui/system';
import {
  API_CONSTANTS,
  CardTypeEnum,
  ContentType,
  EMPTY_PAGE_TEXT,
  extractDate,
  extractTime,
  MediaStatus,
  MediaStatusType,
  REFETCH_INTERVAL,
  VideoDetailsType,
} from '../../utils';
import { useRouter } from 'next/router';
import {
  AvatarVideosResponse,
  getAllAvatarCreatedVideos,
  useGetAllAvatarCreatedVideos,
} from '../../../t2c-fe/services/creations/getAllAvatarCreatedVideos';
import { SectionTitle, Styles } from '@t2c/shared-fe';
import EmptyPage from '../../../t2c-fe/Common/EmptyPage';
import { Grid } from '@mui/material';
import { AvatarCard } from '../avatar-library/PrivateAvatarCard';
import { Button } from '@mui/material';
import { Typography } from '@mui/material';
import { InfiniteData } from '@tanstack/react-query';

interface Props {
  title?: string;
  videoData: InfiniteData<AvatarVideosResponse>;
  loading: boolean;
  refetchData: () => void;
}

export const AvatarVideosSection: React.FC<Props> = ({
  title,
  loading,
  refetchData,
  videoData,
}) => {
  const { push } = useRouter();

  // const [displayData, setDisplayData] = useState([]);

  // useEffect(() => {
  //   if (!loading && videoData) setDisplayData(videoData?.data);
  // }, [videoData]);

  const hanldleRouting = (id: string, status: MediaStatus) => {
    if (status === MediaStatus.Success) {
      push(`/video/${id}`);
    }
    if (status === MediaStatus.NotStarted) {
      push(`/create-video-details?draftVideoId=${id}`);
    }
    return;
  };
  
  console.log('Vii', videoData)

  const handleViewAll = () => {
    push('/your-videos');
  };
  return (
    <Box sx={{ width: '95%' }} pb={2}>
      <Box display={'flex'} justifyContent={'space-between'} mb={2}>
        <Typography variant="h5">{title ? title : 'Avatar Videos'}</Typography>
        <Button onClick={handleViewAll}>View All</Button>
      </Box>
      {videoData?.pages?.length && videoData.pages[0].count === 0 && !loading ? (
        <EmptyPage text={EMPTY_PAGE_TEXT.video} type={ContentType.Video} />
      ) : (
        <Grid container spacing={4}>
          {videoData?.pages?.map((page, pageIndex) => (
            <Fragment key={pageIndex}>
              {page?.data?.map((data: VideoDetailsType, index) => {
                return (
                  <Grid item flex={1} xs={12} sm={6} md={4} lg={3} key={index}>
                    <AvatarCard
                      avatarLogo={data?.avatar?.thumbnail}
                      avatarName={data.name}
                      status={data.status}
                      message="We hit a glitch in the matrix! Your video didn’t make it. Give it another shot! "
                      handleClick={() => {
                        hanldleRouting(data.id, data.status);
                      }}
                      type={CardTypeEnum.LipsyncVideo}
                      date={extractDate(data.updatedAt ? data.updatedAt : data.createdAt)}
                      time={extractTime(data.updatedAt ? data.updatedAt : data.createdAt)}
                      creationId={data.id}
                      url={data.processedVideo}
                      refetchData={refetchData}
                      draftStatus={data.draftStatus}
                      draftMessage={'Draft'}
                    />
                  </Grid>
                );
              })}
            </Fragment>
          ))}
        </Grid>
      )}
    </Box>
  );
};

const styles: Styles = {
  cardContainer: {
    minHeight: 180,
  },
  card: {
    width: 360,
  },
  loader: {
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '20%',
  },
};
